import { __rest } from '../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { Button } from '../Components/ui/button.js';
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '../Components/ui/tooltip.js';
import { cn } from '../lib/utils.js';

const Actions = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (React__default.createElement("div", Object.assign({ className: cn('tw:inline-flex tw:items-center tw:gap-2 tw:rounded-lg tw:bg-[#f6f8fa] tw:p-2', className) }, props), children));
};
const Action = (_a) => {
    var { tooltip, children, label, className } = _a, props = __rest(_a, ["tooltip", "children", "label", "className"]);
    const button = (React__default.createElement(Button, Object.assign({ className: cn('tw:relative tw:size-8 tw:cursor-pointer tw:rounded-md tw:bg-white tw:p-0 tw:text-foreground tw:hover:bg-gray-50', className), size: "icon", type: "button", variant: "ghost" }, props),
        children,
        React__default.createElement("span", { className: "tw:sr-only" }, label || tooltip)));
    if (tooltip) {
        return (React__default.createElement(TooltipProvider, null,
            React__default.createElement(Tooltip, null,
                React__default.createElement(TooltipTrigger, { asChild: true }, button),
                React__default.createElement(TooltipContent, null,
                    React__default.createElement("p", null, tooltip)))));
    }
    return button;
};

export { Action, Actions };
//# sourceMappingURL=actions.js.map
